import { combineReducers } from "redux";

import * as auth from "./auth";
import * as settings from "./settings";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  settings: settings.reducer,
});
